import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { TimelineMax } from "gsap";
import HeadFromModel from "./head-from-model.vue";
import { Kind } from "./head-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'head-pair',
  props: {
    leftHeadKind: {},
    rightHeadKind: {},
    headId: {},
    containerForTooltips: { default: "body" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// template refs
const leftHead = ref<HTMLElement | null>(null);
const rightHead = ref<HTMLElement | null>(null);

const isSoloHeadLoaded = ref(false);
const isViewpointsHeadLoaded = ref(false);
const hasSoloReport = ref<boolean | null>(false);
const hasViewpointsReport = ref<boolean | null>(false);

function soloHeadLoaded(hasData: boolean): void {
  isSoloHeadLoaded.value = true;
  hasSoloReport.value = hasData;
}

function viewpointsHeadLoaded(hasData: boolean): void {
  isViewpointsHeadLoaded.value = true;
  hasViewpointsReport.value = hasData;
}

function hideLeftHead(tl: TimelineMax): void {
  tl.to(leftHead.value!, 1, { autoAlpha: 0 }, 0);
}

function displayLeftHead(tl: TimelineMax): void {
  tl.to(leftHead.value!, 0, { autoAlpha: 1 }, 0);
}

function toggleBackground(tl: TimelineMax, duration: number, alphaValue: number): void {
  tl.to($(rightHead.value!).find(".head-background"), duration, { autoAlpha: alphaValue }, 0);
}

function centerRightHead(tl: TimelineMax): void {
  tl.to(rightHead.value!, 1, { marginLeft: "-100%", width: "100%", marginTop: "18%" }, 0);
  toggleBackground(tl, 1, 0);
}

function moveRightHeadBackInPlace(tl: TimelineMax): void {
  tl.to(rightHead.value!, 0, { marginLeft: 0, width: "49.5%", marginTop: "0" }, 0);
  toggleBackground(tl, 0, 1);
}

__expose({
  hideLeftHead,
  displayLeftHead,
  centerRightHead,
  moveRightHeadBackInPlace,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["head-pair", { 'head-pair__hidden': !isSoloHeadLoaded.value && !isViewpointsHeadLoaded.value }])
  }, [
    _createElementVNode("div", {
      class: "head-pair__left",
      ref_key: "leftHead",
      ref: leftHead
    }, [
      _createVNode(HeadFromModel, {
        kind: _ctx.leftHeadKind,
        headId: _ctx.headId,
        onOnDataLoaded: soloHeadLoaded,
        containerForTooltips: _ctx.containerForTooltips,
        whiteBackground: true
      }, null, 8, ["kind", "headId", "containerForTooltips"])
    ], 512),
    _createElementVNode("div", {
      class: "head-pair__right",
      ref_key: "rightHead",
      ref: rightHead
    }, [
      _createVNode(HeadFromModel, {
        kind: _ctx.rightHeadKind,
        headId: _ctx.headId,
        onOnDataLoaded: viewpointsHeadLoaded,
        containerForTooltips: _ctx.containerForTooltips,
        whiteBackground: true
      }, null, 8, ["kind", "headId", "containerForTooltips"])
    ], 512)
  ], 2))
}
}

})